export enum ClientMessageType {
    Error = 0,
    Warning = 1,
    Info = 2
}

export interface ClientMessage {
    message: string,
    messageType: ClientMessageType,
    errorId: string
    clearMessages?: boolean
}

export interface ClientMessageWithError {
    errorId: string,
    messages: ClientMessage[]
}

export const ValidationErrorEventKey = 'ValidationError';
export const GeneralErrorEventKey = 'GeneralError';

export interface ValidationErrorEvent {
    errorId: string;
    messagesId: string;
    messages: ClientMessage[];
    handled: () => void;
}

export interface State {
    basketId: string;
    market: string;
    culture: string;
}

export interface Footer {
    imageUrl: string;
}

export interface ContentRoot {
    footer: Footer;
}
